<template>
  <div :class="$style.wrapper">
    <div :class="$style.left">
      <div :class="$style.avatar" :style="{ backgroundImage: `url(${from.avatar})`}"></div>
      <div v-if="like" :class="$style.like">
        {{like.name}}
      </div>
    </div>
    <div :class="$style.right">
      <div :class="$style.top">
        <span :class="$style.name">{{from.name}}</span>
        <span :class="$style.date">{{date}}</span>
      </div>
      <div :class="{ [$style.text]: true, [$style.sticker]: sticker }"><slot /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Message',
  props: {
    from: Object,
    like: Object,
    date: String,
    sticker: Boolean,
  },
}
</script>
<style lang="scss" module>
@import './Message.scss';
</style>
